export enum ScatterLineKeys {
  OVERALL = "overall",
  PERKS = "perks",
  CELEBRATION = "celebration",
  WELLNESS = "wellness",
  CULTURE_HUB = "cultureHub",
  OVERALL_LAST = "overallLast",
  PERKS_LAST = "perksLast",
  CELEBRATION_LAST = "celebrationLast",
  WELLNESS_LAST = "wellnessLast",
  CULTURE_HUB_LAST = "cultureHubLast"
}

export const LAST_SUFFIX = "Last"
